import { Outlet } from "react-router-dom";
import { NavBar } from "../../navigation/NavBar";

export function PublicLayout() {
  return (
    <>
      <NavBar frosted />
      <Outlet />
    </>
  );
}
